import { toRef, resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, renderSlot, createCommentVNode, withDirectives, mergeProps, vModelDynamic, createVNode, withCtx, createTextVNode, toDisplayString } from "vue";
import { useField } from "vee-validate";
import UikitInputError from "./InputError.vue.es.js";
import UikitInputMessage from "./InputMessage.vue.es.js";
/* empty css              */
import _export_sfc from "../../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "UikitInput",
  components: {
    UikitInputError,
    UikitInputMessage
  },
  props: {
    modelValue: {
      type: [String, Number, Object],
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    rules: {
      type: String,
      default: ""
    },
    autocomplete: {
      type: [Boolean, String],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    areErrorsDynamic: {
      type: Boolean,
      default: false
    },
    hint: String,
    inputmode: {
      type: String,
      default: "text"
    },
    legend: {
      type: Boolean,
      default: false
    },
    loading: Boolean,
    placeholder: {
      type: String,
      default: ""
    },
    readonly: {
      type: Boolean,
      default: false
    },
    debounceValidation: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: "text"
    },
    variant: {
      type: String,
      default: "old"
    },
    maxlength: Number,
    validateOnValueUpdate: {
      type: Boolean,
      default: true
    },
    syncVModel: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:modelValue", "blur", "focus", "change", "keypress"],
  setup(props) {
    const name = toRef(props, "name");
    const {
      value,
      errorMessage,
      handleBlur: handleFieldBlur,
      handleChange: handleFieldChange,
      meta,
      validate
    } = useField(name, props.rules, {
      initialValue: props.modelValue,
      syncVModel: props.syncVModel,
      validateOnValueUpdate: props.validateOnValueUpdate
    });
    return { value, errorMessage, handleFieldBlur, handleFieldChange, meta, validate };
  },
  data: function() {
    return {
      hasBlured: false,
      focused: false
    };
  },
  computed: {
    classes() {
      return {
        "with-input-prefix": this.$slots.prefix,
        "with-input-suffix": this.$slots.suffix,
        "with-legend": this.legend,
        [this.variant]: this.variant !== "old"
      };
    },
    inputWrapperClasses() {
      return {
        "input-wrapper-focus": this.focused,
        "input-wrapper-disabled": this.disabled
      };
    },
    isEmpty() {
      return !(this.value || this.value && !this.value.length);
    }
  },
  methods: {
    focus() {
      this.$refs.inner.focus();
    },
    blur() {
      this.$refs.inner.blur();
    },
    handleInput(e) {
      this.$emit("update:modelValue", e.target.value);
    },
    handleChange(e) {
      this.handleFieldChange(e.target.value);
      this.$emit("change", e.target.value);
    },
    handleFocus(e) {
      this.focused = true;
      this.$emit("focus", e.target.value, e);
    },
    handleBlur(e) {
      this.handleFieldBlur(e);
      this.focused = false;
      this.hasBlured = true;
      this.$emit("blur", e.target.value);
      if (this.meta.touched && !this.meta.dirty && !this.meta.validated) {
        this.validate();
      }
    },
    handleKeypress(e) {
      this.$emit("keypress", e);
    }
  }
};
const _hoisted_1 = {
  key: 0,
  class: "input-prefix"
};
const _hoisted_2 = { class: "input-legend-wrapper" };
const _hoisted_3 = ["inputmode", "autocomplete", "disabled", "name", "placeholder", "readonly", "type", "maxlength"];
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  key: 1,
  class: "input-suffix"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_uikit_input_error = resolveComponent("uikit-input-error");
  const _component_uikit_input_message = resolveComponent("uikit-input-message");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["uikit-input type-input", $options.classes])
  }, [
    createElementVNode("div", {
      class: normalizeClass(["input-wrapper", {
        ...$options.inputWrapperClasses,
        "input-wrapper-invalid": !!$setup.errorMessage,
        empty: $options.isEmpty
      }])
    }, [
      _ctx.$slots.prefix ? (openBlock(), createElementBlock("div", _hoisted_1, [
        renderSlot(_ctx.$slots, "prefix", {}, void 0, true)
      ])) : createCommentVNode("", true),
      createElementVNode("div", _hoisted_2, [
        withDirectives(createElementVNode("input", mergeProps({
          ref: "inner",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.value = $event)
        }, _ctx.$attrs, {
          class: ["inner", {
            invalid: !!$setup.errorMessage,
            empty: $options.isEmpty
          }],
          inputmode: $props.inputmode,
          autocomplete: $props.autocomplete,
          disabled: $props.disabled,
          name: $props.name,
          placeholder: $props.placeholder,
          readonly: $props.readonly,
          type: $props.type,
          maxlength: $props.maxlength,
          onBlur: _cache[1] || (_cache[1] = (...args) => $options.handleBlur && $options.handleBlur(...args)),
          onFocus: _cache[2] || (_cache[2] = (...args) => $options.handleFocus && $options.handleFocus(...args)),
          onKeypress: _cache[3] || (_cache[3] = (...args) => $options.handleKeypress && $options.handleKeypress(...args)),
          onChange: _cache[4] || (_cache[4] = (...args) => $options.handleChange && $options.handleChange(...args)),
          onInput: _cache[5] || (_cache[5] = (...args) => $options.handleInput && $options.handleInput(...args))
        }), null, 16, _hoisted_3), [
          [vModelDynamic, $setup.value]
        ]),
        $props.legend ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: "input-label",
          innerHTML: $props.placeholder
        }, null, 8, _hoisted_4)) : createCommentVNode("", true)
      ]),
      _ctx.$slots.suffix ? (openBlock(), createElementBlock("div", _hoisted_5, [
        renderSlot(_ctx.$slots, "suffix", {}, void 0, true)
      ])) : createCommentVNode("", true)
    ], 2),
    createVNode(_component_uikit_input_error, {
      display: !!$setup.errorMessage
    }, {
      default: withCtx(() => [
        createTextVNode(toDisplayString($setup.errorMessage), 1)
      ]),
      _: 1
    }, 8, ["display"]),
    createVNode(_component_uikit_input_message, { message: $props.hint }, null, 8, ["message"])
  ], 2);
}
const UikitInput = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-53bcbf13"]]);
export {
  UikitInput as default
};
//# sourceMappingURL=Input.vue.es.js.map
